import { useContext } from 'react';
import { I18nextContext } from 'gatsby-plugin-react-i18next';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import ArrowButton from '../Atoms/ArrowButton';
import Link from '../Atoms/Link';
import { dateFormatOptions } from '../../utils/i18n/format';

const imageQuery = graphql`
query {
  fallbackImage: file(name: {eq: "Omega-1"}) {
    name
    childImageSharp {
      gatsbyImageData(
        placeholder: DOMINANT_COLOR,
        width: 679,
        formats: AUTO
        )
    }
  }
}`;

type MagazineHeroProps = {
  mostRecentArticle: {
    edges: [
      {
        node: WatchProject21Api.Magazine;
      }
    ]
  }
};

const MagazineHero = ({ mostRecentArticle }: MagazineHeroProps) => {
  const { fallbackImage } = useStaticQuery(imageQuery);
  const { language } = useContext(I18nextContext);

  const article = mostRecentArticle.edges[0].node;
  const date = new Date(article.createdAt).toLocaleDateString(language, dateFormatOptions)

  return (
    <section className="pt-24 lg:pt-64 px-4 lg:px-8 w-full">
      <div className="flex-col justify-center max-w-screen-2xl w-full mx-auto">
        <div className="flex flex-col-reverse lg:flex-row justify-between">
          <div className="lg:w-1/12 xl:block hidden" />
          <div className="lg:w-4/12">
            <h2 className="font-cirka text-xl text-primary hidden" >{article.subTitle}</h2>
            <h1 className="font-cirka text-6xl text-left text-primary my-8 md:w-3/4" >{article.title}</h1>
            <time className="text-gray-400 text-lg" dateTime={article.createdAt}>{date}</time>
            <p className="my-8">{article.topText.replace(/<\/?[^>]+(>|$)/g, "").split(' ', 40).join(" ")}...</p>
            <Link to={`/magazine/${article.slug}`} className="no-animation">
              <ArrowButton />
            </Link>
          </div>
          <div className="lg:w-1/12 xl:block hidden" />
          <div className="w-full lg:w-1/2">
            <GatsbyImage image={fallbackImage.childImageSharp.gatsbyImageData} alt="watch" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default MagazineHero;

